<template>
    <div class="form-group">
        <input v-model="searchTerm"  type="text" class="form-control" @focus="isDropdownOpen = true" @blur="closeDropdown"
            @input="handleInput" :placeholder="placeholder" />
    </div>
    <ul v-if="isDropdownOpen" class="dropdown-menu mt-2" style="display: block;">
        <li class="dropdown-item" v-for="option in filteredOptions" :key="option.id"  @click="selectOption(option)">
            {{ option.name }}
        </li>
    </ul>
</template>

<script>
import { ref, computed } from 'vue';

export default {
    name: 'SoftSelect',
    emits: ['callback-event', 'selected-value'],
    props: {
        options: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        selectedValue: {
           type: Object,
           required: false
        }

    },
    setup(props, { emit }) {
        const searchTerm = ref(props.selectedValue != null ? props.selectedValue.name : "");
        const isDropdownOpen = ref(false);
        const selectedOption = ref(null);

        const handleInput = () => {
            isDropdownOpen.value = true;
        };

        const closeDropdown = () => {
            setTimeout(() => {
                isDropdownOpen.value = false;
            }, 200);
        };

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const filteredOptions = computed(() => {
            const data = props.options.filter((option) =>
                option.name.toLowerCase().includes(searchTerm.value.toLowerCase())
            );
            return data;
        });

        const selectOption = (option) => {
            emit('callback-event', option);
            emit('selected-value', option);
            selectedOption.value = option;
            searchTerm.value = option.name;
            isDropdownOpen.value = false;
        };

        return {
            searchTerm,
            isDropdownOpen,
            selectedOption,
            handleInput,
            closeDropdown,
            toggleDropdown,
            filteredOptions,
            selectOption,
        };
    },
};
</script>

<style scoped>
/* Estilos para el componente */
.custom-select {
    position: relative;
    display: inline-block;
    width: 100%;
}

.input-group {
    width: 100%;
}

.dropdown-menu {
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}
</style>
